module.exports = __webpack_public_path__ + "static/img/drag-icon.c7ecd665.svg";